import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterLink, RouterLinkActive, Router, NavigationEnd } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { AuthService } from './auth/auth.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatToolbarModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    MatDividerModule
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  private authService = inject(AuthService);
  private router = inject(Router);
  
  showToolbar = true;
  
  constructor() {
    // Subscribe to router events to determine when to show/hide toolbar
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      // Hide toolbar on auth pages
      const authRoutes = ['/login', '/reset-password'];
      this.showToolbar = !authRoutes.some(route => event.url.startsWith(route));
      
      // Check if we need to redirect to create a self contact
      this.checkSelfContact(event.url);
    });
  }

  getEmail() {
    return JSON.parse(localStorage.getItem('user_profile') || '{}').email
  }

  logout() {
    this.authService.signOut();
  }

  showUsers() {
    if (JSON.parse(localStorage.getItem('user_profile') || '{}').id === 1) {
      return true;
    }
    return false;
  }
  
  // Check if the user has a self contact set up
  private checkSelfContact(currentUrl: string) {
    // Skip this check for auth pages and the contacts page (to avoid redirect loops)
    if (currentUrl.startsWith('/login') || 
        currentUrl.startsWith('/reset-password') || 
        currentUrl.startsWith('/contacts')) {
      return;
    }
    
    // Get the profile from localStorage
    const profileJson = localStorage.getItem('user_profile');
    if (profileJson) {
      try {
        const profile = JSON.parse(profileJson);
        
        // Check if self property is 0, null, or undefined
        if (profile.self === 0 || profile.self === null || profile.self === undefined) {
          this.router.navigate(['/contacts'], { 
            queryParams: { requireSelfContact: true } 
          });
        }
      } catch (error) {
        console.error('Error parsing profile in app component:', error);
      }
    }
  }
}